// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__EHqQp","header":"ReportDetails_header__1TOL6","title":"ReportDetails_title__1oUxS","left":"ReportDetails_left__4l6wK"};